import React, { useEffect, useState } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import Checkbox from '@mui/material/Checkbox'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { setReduxValue } from 'src/redux/slices/eLearning/enroll'
import { StyledBox } from './Styled'
import { handleOpenDialog } from './events'

const Consent = () => {
  const consent = useSelector(
    (state) => state.eLearningEnroll.consent,
    shallowEqual
  )
  const dispatch = useDispatch()
  const [checkConsent, setCheckConsent] = useState(consent)

  useEffect(() => {
    dispatch(setReduxValue({ index: 'consent', value: checkConsent }))
  }, [checkConsent])
  return (
    <StyledBox>
      <Checkbox
        onChange={(e) => setCheckConsent(e.target.checked)}
        name="consent"
        checked={checkConsent}
      />
      <Typography>
        ยอมรับ{' '}
        <Link
          component="span"
          onClick={() => dispatch(handleOpenDialog('consentBodyText'))}
        >
          นโยบายคุ้มครองข้อมูลส่วนบุคคล
        </Link>
        สำหรับการอบรมเก็บชั่วโมงออนไลน์หลักสูตรระดับสูงและ
        <Link
          component="span"
          onClick={() => dispatch(handleOpenDialog('TERMS_AND_CONDITIONS_'))}
        >
          ข้อตกลงและเงื่อนไขการใช้งาน
        </Link>
      </Typography>
    </StyledBox>
  )
}

export default Consent
